export default "__VITE_ASSET__DHdgW5ni__"